import { Routes, RouterModule } from '@angular/router';

export const FullLayout_ROUTES: Routes = [
    {
        path: 'authentication',
        loadChildren: () => import('../../authentication/authentication.module').then(m => m.AuthenticationModule)
    },
    {
        path: 'ochs',
        loadChildren: () => import('../../ochs/ochs.module').then(m => m.OchsModule)
    }
];
